import React, { useState, useEffect } from 'react';
import { IconButton, Typography, TextField } from '@mui/material';
import { ReactComponent as EditIcon } from '../../../assets/scheduler/edit.svg';
import './EditableTitle.scss';

interface EditableTitleProps {
  name: string;
  onUpdateName?: (name: string) => void;
  disableInteraction?: boolean;
  className?: string;
}

export const EditableTitle: React.FC<EditableTitleProps> = ({
  name,
  onUpdateName,
  disableInteraction = false,
  className = '',
}) => {
  const [editableTitle, setEditableTitle] = useState<string>(name);
  const [isEditingTitle, setIsEditingTitle] = useState(false);

  useEffect(() => {
    setEditableTitle(name);
    setIsEditingTitle(false);
  }, [name]);

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newCleanTitle = event.target.value;
    setEditableTitle(newCleanTitle);
    onUpdateName?.(newCleanTitle);
  };

  const handleStartEditTitle = () => {
    setIsEditingTitle(true);
  };

  if (isEditingTitle) {
    return (
      <TextField
        value={editableTitle}
        onChange={handleTitleChange}
        disabled={disableInteraction}
        className={`editable-title__input ${className}`}
        variant="standard"
        autoFocus
        InputProps={{
          disableUnderline: true,
          className: 'editable-title__input-field',
        }}
      />
    );
  }

  return (
    <div className={`editable-title__container ${className}`}>
      <Typography className="editable-title__text">{editableTitle}</Typography>
      {!disableInteraction && (
        <IconButton
          size="small"
          onClick={handleStartEditTitle}
          className="editable-title__edit-button"
        >
          <EditIcon />
        </IconButton>
      )}
    </div>
  );
};
